import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Proposal } from 'src/app/models/proposal';
import { ProposalImage } from 'src/app/models/proposal-image';
import { ActivatedRoute } from '@angular/router';
import { CreateProposalDTO } from 'src/app/models/createproposaldto';
import cloneDeep from 'lodash/cloneDeep';
import { DataService } from 'src/app/services/data.service';
import { ProposalDetailsComponent } from '../proposal-details/proposal-details.component';
import { MatTabChangeEvent } from '@angular/material';
import { ProposalService } from 'src/app/services/proposal.service';


@Component({
  selector: 'app-view-proposal',
  templateUrl: './view-proposal.component.html',
  styleUrls: ['./view-proposal.component.scss']
})
export class ViewProposalComponent implements OnInit {
  @Input() showCloseWindowButton: boolean = true;
  id:number;
  isCriticalPart: boolean;
  selectedTabIndex: number = 0;
  constructor(
    private proposalService:ProposalService,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
  }

  selectedTabChange(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
    this.proposalService.RefreshProposalTabsSelectedIndex(event.index);
  }
  
  proposalLoaded(proposal) {
    this.isCriticalPart = proposal && proposal.PartInfo && proposal.PartInfo.Parts && proposal.PartInfo.Parts[0].IsCriticalPart;
  }

  closeWindow()
{
    window.close();
}


}
